// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Images
import bgFront from "assets/images/Contact2.jpeg";
import bgBack from "assets/images/course1.jpeg";
import courseIcon from "assets/images/course.jpeg";
import teamIcon from "assets/images/teamsmall.jpeg";
import GalleryIcon from "assets/images/GallerySmall.jpeg";
import AboutIcon from "assets/images/about.jpeg";

function Information() {
  return (
    <MKBox component="section" py={1} my={1}>
      <Container>
        <Grid container item xs={20} spacing={1} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={15} lg={5} sx={{ height: { xs: 200, md: 450 } }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                title={
                  <>
                    <br /> <br /> <br /> <br /> <br />
                  </>
                }
                //description="All the MUI components that you need in a development have been re-design with the new look."
              />
              <RotatingCardBack
                image={bgBack}
                //title="Discover More"
                //description="You will save a lot of time going from prototyping to full-functional code because all elements are implemented."
                /*action={{
                type: "internal",
                route: "/sections/page-sections/page-headers",
                label: "start with header",
              }}*/
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <a
                  href="/#/pages/landing-pages/cources"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <DefaultInfoCard
                    image={courseIcon}
                    icon="content_copy"
                    title="Dive Courses"
                    description="Select your favorite course and contact us for more details."
                  />
                </a>
              </Grid>
              <Grid item xs={12} md={6}>
                <a
                  href="/#/pages/landing-pages/about-us"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <DefaultInfoCard
                    image={AboutIcon}
                    icon="flip_to_front"
                    title="About us"
                    description="We are located on the beautiful beach of Mount Lavinia.."
                  />
                </a>
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 2 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  image={GalleryIcon}
                  icon="price_change"
                  title="Dive Gallery"
                  description="It's all about dive with a smile...."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <a
                  href="/#/pages/landing-pages/our-team"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <DefaultInfoCard
                    image={teamIcon}
                    icon="Gallery"
                    title="Our Team"
                    description="Meet the Scuba Addicts Team...."
                  />
                </a>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
